import React from 'react'
import { useTranslation } from 'react-i18next';
import translations from "../../Components/Translations/Translations";

const Anandi = ({ details }) => {
    const { t, i18n } = useTranslation();
    const storedLanguage = localStorage.getItem("lang") || "en";
    const selectedTranslation = translations[storedLanguage] || translations.en;
    return (
        <div className='flex flex-col items-center justify-center mt-14'>
            <h3>{selectedTranslation.labels.detailstamilyoga}</h3>
            <div className='grid grid-cols-4 gap-24 p-10 mt-6 ml-6'>
                <div className='flex items-center justify-start '>
                    <p className='mt-2 ml-2'><span className='text-lg font-semibold'>{t("Anandadi")}</span><br /> {details?.["Anandadi Yoga"] || "None"}</p>
                </div>
                <div className='flex items-center justify-start '>
                    <p className='mt-2 ml-2'><span className='text-lg font-semibold'>{t("Tamil Yoga")}</span> <br />{localStorage.getItem("lang") === 'te' ? details?.["Tamil Yogalu"] : details?.["Tamil Yoga"]  || "None"}</p>
                </div>

                <div className='flex items-center justify-start '>
                    <p className='mt-2 ml-2'><span className='text-lg font-semibold'>{t("Jeevanama")} </span><br />
                        {details?.["Jeevanama "]
                            ? details?.["Jeevanama "].map((data, index) => (
                                <span key={index}>{data}</span>
                            ))
                            : "None"}
                    </p>
                </div>
                <div className='flex items-center justify-start'>
                    <p className='mt-2 ml-2'><span className='text-lg font-semibold'>{t("Surya Pada")}</span>  <br />{details?.["Surya Pada"] ? details["Surya Pada"] : "None"}</p>
                </div>
            </div>
        </div>
    )
}

export default Anandi;